// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterToggleGroup } from '@/components/filter-toggle-group';
import {
  ASSET_LOCATION_REPORT_GROUP_OPTIONS,
  AssetLocationReportGroup,
} from '@/report/constants/group-options';
import { Stack, Typography } from '@mui/material';

interface Props {
  value: AssetLocationReportGroup;
  onChange: (value: AssetLocationReportGroup) => void;
}

export function AssetLocationReportGroupControl(props: Props) {
  return (
    <Stack direction="row" alignSelf="end" alignItems="center" spacing={1}>
      <Typography variant="subtitle2">Group by</Typography>
      <FilterToggleGroup
        value={props.value}
        options={ASSET_LOCATION_REPORT_GROUP_OPTIONS}
        onChange={props.onChange}
        ariaLabel="Asset location report grouping"
      />
    </Stack>
  );
}
